import copy from 'copy-to-clipboard';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Alert from 'ViatoUi/Extranet/Surfaces/Alert';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { snackbar } from 'ViatoUi/Shared/Feedback/Snackbar';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Paragraph } from 'ViatoUi/Shared/Typo';
import DimmerPopup from 'ViatoUi/Web/DimmerPopup';

import styles from './CopyLink.module.scss';

const CopyLink = ({ visible, onClose }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation('contractGenerator');

	const sessionId = useSelector(contractGeneratorSelectors.getSessionId);
	const url = window.location.href.split('?')[0].split('#')[0];

	return (
		<DimmerPopup
			buttonText={t('app.userActions.close')}
			headline={t('layouts.share.modals.copyLink.headline')}
			visible={visible}
			onClick={() => {
				onClose();
				dispatch(contractGeneratorOperations.setDataToSubmit({ captchaResponse: '' }));
			}}
		>
			<Alert type='success'>{t('layouts.share.modals.copyLink.success')}</Alert>
			<Spacer height='l' />
			<FlexBox alignItems='center' className={styles.copyToClipboard} justifyContent='space-between'>
				<FlexBox
					alignItems='center'
					className={styles.link}
					onClick={() => {
						copy(`${url}?cgs=${sessionId}`);
						snackbar.bright(
							<FlexBox alignItems='center'>
								<Icon color='silver' icon='fa-check-circle' iconWeight='fal' size='m' spaceAfter />{' '}
								<Paragraph font='normal' noBreak>
									{t('layouts.share.modals.copyLink.toast')}
								</Paragraph>
							</FlexBox>,
							{
								autoClose: true,
								closeButton: false,
								closeOnClick: false
							}
						);
					}}
				>
					{url}?cgs={sessionId}
				</FlexBox>
				<FlexBox
					alignItems='center'
					className={styles.icon}
					justifyContent='center'
					tooltip={t('layouts.share.modals.copyLink.tooltip')}
					onClick={() => {
						copy(`${url}?cgs=${sessionId}`);
						snackbar.bright(
							<FlexBox alignItems='center'>
								<Icon color='silver' icon='fa-check-circle' iconWeight='fal' size='m' spaceAfter />{' '}
								<Paragraph font='normal' noBreak>
									{t('layouts.share.modals.copyLink.toast')}
								</Paragraph>
							</FlexBox>,
							{
								autoClose: true,
								closeButton: false,
								closeOnClick: false
							}
						);
					}}
				>
					<Icon className={styles.iconInner} color='silver' icon='fa-clipboard' iconWeight='fal' size='xl' />
				</FlexBox>
			</FlexBox>
		</DimmerPopup>
	);
};

CopyLink.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired
};

export default CopyLink;
